<template>

</template>
<script>
import slider from 'vue-concise-slider'
export default{
  data () {
    return {
      urlData:{}
    }
  },
  mounted: function () {
    let url = this.getUrlParam ('action')  || this.getUrlParam ('home')
    sessionStorage.setItem('home', url)
    console.log(url,sessionStorage.getItem('home'))
    // const clientAppId = this.getUrlParam ('clientAppId');
    // sessionStorage.setItem("clientAppId", clientAppId);

    if(!sessionStorage.getItem('token')){
      this.silentAuthorization()
    }else{
      this.action()
    }
  },
  methods:{
    action () {
      this.map()
      let url = this.getUrlParam ('home') || this.urlData.home ;
      let action = this.getUrlParam ('action') || this.urlData.action ;
      console.log(url,action,'调转')
      if(action){
	      sessionStorage.setItem('home', action)
        this.$router.push({
          name:action,
          params:this.urlData
        })
      }else{
        if(!url){
          url = 'homePage'
        }
        sessionStorage.setItem('home', url)
        this.$router.push({
          name:url,
          params:this.urlData
        })
      }
    },
    map () {
      let data = {};
      let src = window.location.href
      let index = src.indexOf("?");
      if(index===-1){
        return data;
      }
      let dataStr = src.substring(src.indexOf("?")+1);
      let dataArray = dataStr.split("&");
      for(let i=0;i<dataArray.length;i++){
        let param = dataArray[i].split("=");
        data[param[0]]=param[1];
      }
      this.urlData = data
    },
    silentAuthorization () {
      // sessionStorage.setItem("token", '6BC62750F100E5BB9F7C');
      // sessionStorage.setItem("userName", '1067959339047849984');
      // this.action()

      const _this = this
      const appid = _this.getUrlParam('appId')
      sessionStorage.setItem('appId', appid)
      const code = _this.getUrlParam('code')
      const returnUrl = window.location.href
      if (code == null || code === '') {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(returnUrl) + '&response_type=code&scope=snsapi_base&state=0#wechat_redirect'
      }
      _this.postRequest('login/loginWeChat/' + appid, {
        code: code,
        state: '0'
      },function(data){
        let token = data.token
        let userName = data.userName
		    sessionStorage.setItem("token", token)
         sessionStorage.setItem("userName", userName)
        _this.action()
      })
    },
    getUrlParam (name) {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
      const r = window.location.search.substr(1).match(reg) // 匹配目标参数
      if (r != null) {
        return unescape(r[2]) // 返回参数值
      } else {
        return null
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue